import {Directive, HostListener} from '@angular/core';
import {ToolsService} from '../services/tools.service';
import {Router} from '@angular/router';

@Directive({
  selector: '[appStaticRedirectClick]',
})
export class StaticRedirectClickDirective {
  private staticRedirectCssClassName = 'static-redirect-click';

  constructor(
    private tools: ToolsService,
    private router: Router,
  ) {}

  @HostListener('click', ['$event'])
  onClick(e) {
    if (
      !this.tools.isNil(e) &&
      !this.tools.isNil(e.target) &&
      e.target.className.indexOf(this.staticRedirectCssClassName) >= 0
    ) {
      this.redirectAction(e.target.dataset?.url);
    }
  }

  private redirectAction(url: string): void {
    if (!this.tools.isNil(url)) {
      this.router.navigateByUrl(url);
    }
  }
}
